// @flow

import { pageActions } from "./pageActionCreator";

const initialState = {
  pageName: null,
  beta: false
};

const pageReducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case pageActions.set_page_name:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
};

export default pageReducer;



// WEBPACK FOOTER //
// ./app/services/pageService/pageReducer.js